import React, { useState, useEffect } from 'react';
import { NotificationData } from '../../types/NotificationData';
import './NotificationModal.scss';

interface NotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmNotification: (emailData: NotificationData) => void;
  notificationData: NotificationData;
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  isOpen,
  onClose,
  onConfirmNotification,
  notificationData
}) => {
  const [from, setFrom] = useState(notificationData.from);
  const [to, setTo] = useState(notificationData.to);
  const [cc, setCc] = useState(notificationData.cc);
  const [subject] = useState(notificationData.subject);
  const [userText, setUserText] = useState(notificationData.userText);

  // Update state when notificationData prop changes
  useEffect(() => {
    setFrom(notificationData.from);
    setTo(notificationData.to);
    setCc(notificationData.cc);
    setUserText(notificationData.userText);
  }, [notificationData]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirmNotification({
      from,
      to,
      cc,
      subject,
      userText
    });
  };

  return (
    <div className="notification-modal-overlay" role="presentation">
      <div
        className="notification-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="notification-modal-title"
      >
        <div className="notification-modal__header">
          <h2 id="notification-modal-title" className="notification-modal__title">
            Edit Notification
          </h2>
          <button
            className="notification-modal__close-button"
            onClick={onClose}
            aria-label="Close notification modal"
          >
            ×
          </button>
        </div>
        
        <div className="notification-modal__content">
          <div className="notification-modal__form">
            <div className="notification-modal__form-group">
              <label htmlFor="email-from" className="notification-modal__label">
                From:
              </label>
              <input
                id="email-from"
                type="text"
                className="notification-modal__input"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              />
            </div>

            <div className="notification-modal__form-group">
              <label htmlFor="email-to" className="notification-modal__label">
                To: <span className="notification-modal__help-text">(comma-separated)</span>
              </label>
              <input
                id="email-to"
                type="text"
                className="notification-modal__input"
                value={to}
                onChange={(e) => setTo(e.target.value)}
              />
            </div>

            <div className="notification-modal__form-group">
              <label htmlFor="email-cc" className="notification-modal__label">
                CC: <span className="notification-modal__help-text">(comma-separated)</span>
              </label>
              <input
                id="email-cc"
                type="text"
                className="notification-modal__input"
                value={cc}
                onChange={(e) => setCc(e.target.value)}
              />
            </div>

            <div className="notification-modal__form-group">
              <label htmlFor="email-subject" className="notification-modal__label">
                Subject:
              </label>
              <input
                id="email-subject"
                type="text"
                className="notification-modal__input"
                value={subject}
                disabled
              />
            </div>

            <div className="notification-modal__form-group">
              <label htmlFor="email-body" className="notification-modal__label">
                Body:
              </label>
              <textarea
                id="email-body"
                className="notification-modal__textarea"
                value={userText}
                onChange={(e) => setUserText(e.target.value)}
                rows={10}
              />
            </div>
          </div>
        </div>
        
        <div className="notification-modal__footer">
          <div className="notification-modal__footer-container">
            <auro-button
              className="notification-modal__cancel-button"
              onClick={onClose}
              aria-label="Go back"
              variant="secondary"
              size="md"
            >
              Go back
            </auro-button>
            <auro-button
              className="notification-modal__confirm-button"
              onClick={handleConfirm}
              aria-label="Confirm notification"
              variant="primary"
              size="md"
              responsive
              fluid
              style={
                {
                  '--ds-auro-button-container-image': 'var(--color-primary, #0074ca)',
                  minWidth: '212px',
                  height: '50px'
                } as React.CSSProperties
              }
            >
              Confirm Notification
            </auro-button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
